import { JourneysLegacyAuthRefreshRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/2fa_setup_/$')({
  component: JourneysLegacyAuthRefreshRoute,
});
